import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import TextArea from "../common/formfields/TextArea";
import UserAvatar from 'react-user-avatar';
//import { uploadImages } from "../../redux/actions/postCommentActions";
import * as apiConfig from "../../api/config";
import Spinner from "../common/Spinner";
import $ from 'jquery';
import "./PostComment.css"

const PostForm = ({
    user,
    post,
    placeholder,
    saveButtonText,
    alwaysShowSubmit,
    onSave,
    onChange,
    onImagesChange,
    saving = false,
    errors = {}
}) => {

    const [imageFormId, setImageFormId] = useState("");
    const [previews, setPreviews] = useState([]);
    const [processing, setProcessing] = useState(false); 

    useEffect(() => {

    }, [])

    useEffect(() => {
        if (previews.length > 0) {
            setTimeout(() => { $(`#image-preview${imageFormId}`).collapse("show") }, 500);

        } else {
            setTimeout(() => { $(`#image-preview${imageFormId}`).collapse("hide") }, 500);

        }
    }, [previews])

    useEffect(() => {
        if (post.images && post.images.length == 0) {
            setPreviews([]); 
        }
        /* Edit Post */
        if (post.id && !post.postId && !post.parentId) {
            setImageFormId(`-editPost-${post.id}`);
        }
        /* New Commment */
        if (!post.id && post.postId && !post.parentId) { 
            setImageFormId(`-${post.postId}`);
        }
        /* Edit Commment */
        if (post.id && post.postId && !post.parentId) {
            setImageFormId(`-editComment-${post.postId}`);
        }
        /* New Reply */
        if (!post.id && post.postId && post.parentId) { 
            setImageFormId(`-${post.postId}-${post.parentId}`);
        }
        /* Edit Reply */
        if (post.id && post.postId && post.parentId) {
            setImageFormId(`-editReply-${post.postId}-${post.parentId}`);
        }

    }, [post])

    //Image upload

    async function uploadMultipleFiles(e) {
        if (e.target.files.length > 0) {
            e.persist();
            setProcessing(true);

            var imagePreviews = [];
            previews.map(p => { imagePreviews.push(p); })

            var images = [];
            post.images.map(f => { images.push(f); });

            for (let i = 0; i < e.target.files.length; i++) {
                const config = {
                    file: e.target.files[i],
                    maxSize: 1280
                };
                const resizedImage = await resizeImage(config)
                images.push({ fileName: resizedImage.data });
                imagePreviews.push(URL.createObjectURL(resizedImage.blob))
                //console.log("upload resized image");

            }

            setPreviews(imagePreviews);
            setProcessing(false);
            onImagesChange(images);
        }
    }

    function openFileUpload() {
        $(`#image-control${imageFormId}`).click();
    }

    function removeImage(index) {
        
        var imagePreviews = [];
        previews.map(p => { imagePreviews.push(p); })
        imagePreviews.splice(index, 1);

        var images = [];

        post.images.map(f => { images.push(f); });
        images.splice(index, 1);

        setPreviews(imagePreviews);
        onImagesChange(images);
        $(`#image-control${imageFormId}`)[0].value = "";
    }

    return (
        
        <div className="compose-post-form-container"> 
            <form onSubmit={onSave} className="">
                {errors.onSave && (
                    <div className="alert alert-danger" role="alert">
                        {errors.onSave}
                    </div>
                )}
                <div className="compose-post-form"> 
                    <div className="compose-post-form-avatar">
                        {user.avatarAvailable ?
                            <UserAvatar className="post-avatar" size="35" name={`${user.firstName} ${user.surname}`} src={`${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}`} />
                            :
                            <div className="post-avatar post-avatar-default"><span className="fas fa-user" /></div>
                        }
                    </div>
                    <div className="compose-post-form-body">
                        <div className="image-btn">
                            <button className="btn btn-link post-options-btn" type="button" onClick={openFileUpload} >
                                <span className="far fa-image"></span>
                            </button>
                        </div>
                        <div className="post-text ">
                            <TextArea
                                name="body"
                                placeholder={placeholder}
                                maxLength="2000"
                                cols="75"
                                rows={($(`.post-input${imageFormId}`).val() != undefined && $(`.post-input${imageFormId}`).val().length > 0) ? "3" : "1" }
                                value={post.body}
                                onChange={onChange}
                                error={errors.body}
                                className={`post-input${imageFormId} form-control form-control-sm`}
                                />
                        </div>
                       
                    </div>
                </div>

 
                {processing &&
                    <div className="form-status">
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> <span>loading...</span>
                    </div>
                }
                <div id={`image-preview${imageFormId}`} className="collapse image-preview-container">
                    <div className="multi-image-preview">
                        {previews.map((url, idx) => {
                            return (
                                <div key={`img-${idx}`} className="image-preview">
                                    <img src={url} alt="..." />
                                    <div className={`delete-preview delete-preview-${idx}`} onClick={() => { removeImage(idx) }} ><span className="fas fa-times"></span></div>
                                </div>
                            )
                        })}
                        <div className="image-preview-add" onClick={openFileUpload} >
                            <div className="fas fa-plus"></div>
                        </div>
                        <input type="file" accept="image/*" style={{ display: "none" }} id={`image-control${imageFormId}`} className="form-control" onChange={uploadMultipleFiles} multiple />
                    </div>
                </div>
                <button type="submit" disabled={post.body.length == 0 || saving} style={!alwaysShowSubmit ? { display: ($(`.post-input${imageFormId}`).val() != undefined && $(`.post-input${imageFormId}`).val().length > 0) ? "block" : "none" } : {}} className="btn btn-info float-right mb-3">
                    {saveButtonText ? saveButtonText : "Post"}
                </button>
            </form>
        </div>
    );
}

PostForm.propTypes = {
    user: PropTypes.object.isRequired,
    post: PropTypes.object.isRequired,
    placeholder: PropTypes.string,
    autoResize: PropTypes.bool,
    saveButtonText: PropTypes.string,
    errors: PropTypes.object,
    onSave: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    saving: PropTypes.bool
}

export default PostForm;

var resizeImage = function (settings) {
    var file = settings.file;
    var maxSize = settings.maxSize;
    var reader = new FileReader();
    var image = new Image();
    var canvas = document.createElement('canvas');
    var dataURItoBlob = function (dataURI) {
        var bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
            atob(dataURI.split(',')[1]) :
            unescape(dataURI.split(',')[1]);
        var mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
        var max = bytes.length;
        var ia = new Uint8Array(max);
        for (var i = 0; i < max; i++)
            ia[i] = bytes.charCodeAt(i);
        return new Blob([ia], { type: mime });
    };
    var resize = function () {
        var width = image.width;
        var height = image.height;
        if (width > height) {
            if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
            }
        } else {
            if (height > maxSize) {
                width *= maxSize / height;
                height = maxSize;
            }
        }
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(image, 0, 0, width, height);
        var dataUrl = canvas.toDataURL('image/png');
        return { blob: dataURItoBlob(dataUrl), data: dataUrl };
    };
    return new Promise(function (ok, no) {
        if (!file.type.match(/image.*/)) {
            no(new Error("Not an image"));
            return;
        }
        reader.onload = function (readerEvent) {
            image.onload = function () { return ok(resize()); };
            image.src = readerEvent.target.result;
        };
        reader.readAsDataURL(file);
    });
};


// WEBPACK FOOTER //
// ./src/components/postComments/PostForm.js